module.exports = __webpack_public_path__ + "static/media/display18.29e3b8fa.jpg";